import React from 'react';
import {
  Breadcrumbs as MuiBreadcrumbs,
  Link,
  Typography,
  Box,
  Chip
} from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const Breadcrumbs = () => {
  const location = useLocation();
  
  const pathnames = location.pathname.split('/').filter((x) => x);

  const getBreadcrumbName = (path) => {
    const pathMap = {
      'complaint_new': 'New Complaint',
      'complaints': 'All Complaints',
      'pending-complaints': 'Pending Complaints',
      'resolved-complaints': 'Resolved Complaints',
      'users': 'Users',
      'category': 'Categories',
      'assemblies': 'Assemblies',
      'districts': 'Districts',
      'settings': 'Settings',
      'profile': 'Profile',
      'backup-restore': 'Backup & Restore',
      'admin': 'Admin Dashboard'
    };
    return pathMap[path] || path.charAt(0).toUpperCase() + path.slice(1);
  };

  const breadcrumbNameMap = {
    '/': 'Dashboard',
  };

  return (
    <Box sx={{ mb: 3 }}>
      <MuiBreadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{
          '& .MuiBreadcrumbs-separator': {
            color: 'text.secondary',
          },
          '& .MuiBreadcrumbs-ol': {
            marginTop: '1em',
            marginBottom: '-3em',
          },
        }}
      >
        <Link
          component={RouterLink}
          to="/"
          color="inherit"
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />
          Dashboard
        </Link>
        
        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const name = getBreadcrumbName(value);

          return last ? (
            <Box key={to} sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography 
                color="text.primary" 
                sx={{ 
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {name}
              </Typography>
              {location.pathname.includes('/complaint/') && (
                <Chip
                  label="View"
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{ ml: 1 }}
                />
              )}
            </Box>
          ) : (
            <Link
              component={RouterLink}
              color="inherit"
              to={to}
              key={to}
              sx={{
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              {name}
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
};

export default Breadcrumbs; 